// extracted by mini-css-extract-plugin
export var container = "_np-0";
export var dotAnimation = "_np-2";
export var dotsLoading = "_np-1";